import "./helper/serviceWorkerKillSwitch";
import "./config/agencyRuntime";
import "./config/ssoRuntime";
import { startAutoVersionReload } from "./helper/autoVersionReload";
import Vue from "vue";
import axios from "axios";
import "./config/axiosSetup";
// Plugins
import App from "./App.vue";
import VueAxios from "vue-axios";
import DashboardPlugin from "./material-dashboard";
import Popover from "vue-js-popover";
import "vue-select/dist/vue-select.css";
import VueJSModal from "vue-js-modal";
import VueClipboard from "vue-clipboard2";
import CKEditor from "ckeditor4-vue";
import VueElementLoading from "vue-element-loading";
import VEmojiPicker from "v-emoji-picker";
import VueLoadmore from "vuejs-loadmore";
import Multiselect from "vue-multiselect";
import VueObserveVisibility from "vue-observe-visibility";
import "vue-datetime/dist/vue-datetime.css";
import { Settings } from "luxon";
import "jquery-highlighttextarea";
import "jquery-highlighttextarea/jquery.highlighttextarea.css";
import FloatingVue from "floating-vue";
Vue.use(FloatingVue);
import "floating-vue/dist/style.css";
Settings.defaultLocale = "vi";
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";
Vue.use(Vuesax, {
    theme: {
        colors: {
            primary: "#FCAF17",
            success: "rgb(23, 201, 100)",
            danger: "rgb(242, 19, 93)",
            warning: "rgb(255, 130, 0)",
            dark: "rgb(36, 33, 69)",
        },
    },
});
Vue.use(DashboardPlugin);
Vue.use(Popover, { tooltip: true });
Vue.use(VueAxios, axios);
Vue.use(VueJSModal, { dialog: true, dynamic: true, injectModalsContainer: true });
Vue.use(VueJSModal);
Vue.use(VueClipboard);
Vue.use(CKEditor);
Vue.component("VueElementLoading", VueElementLoading);
Vue.component("multiselect", Multiselect);
Vue.config.productionTip = false;
Vue.use(VEmojiPicker);
Vue.use(VueLoadmore, {
    lang: "en-US",
});
Vue.use(VueObserveVisibility);
import io from "socket.io-client";
import router from "./router";
import store from "./store";
import NotificationService from "./store/services/NotificationService";
import { helpers } from "./helper/helpers";
import { resolveSocketUrl } from "./helper/socketUrl";
import { loadSsoConfig } from "./helper/sso";
import Cookies from "js-cookie";
const ws = io(resolveSocketUrl() + "/", {
    transports: ["websocket"],
});
let accessTokenLocal = localStorage.getItem("access_token");
let userIdLocal = localStorage.getItem("user_id");
const accessTokenCookie = helpers.getCookie("access_token");
const userIdCookie = helpers.getCookie("user_id");
let accessToken = accessTokenLocal;
let userId = userIdLocal;
if (accessTokenLocal == null) {
    accessToken = accessTokenCookie;
    localStorage.setItem("access_token", accessTokenCookie);
}
if (userIdLocal == null) {
    userId = userIdCookie;
    localStorage.setItem("user_id", userIdCookie);
}
let vuex = localStorage.getItem("vuex");
// iOS WebView: localStorage đầy → QuotaExceeded / JSON hỏng → Messenger trống.
try {
    if (vuex && vuex.length > 1_800_000) {
        const parsed = JSON.parse(vuex);
        const slim = {
            auth: parsed && parsed.auth ? parsed.auth : {},
        };
        localStorage.setItem("vuex", JSON.stringify(slim));
        vuex = localStorage.getItem("vuex");
    }
}
catch {
    try {
        localStorage.removeItem("vuex");
    }
    catch {
        /* ignore */
    }
    vuex = null;
}
if (accessToken !== null && accessToken !== "") {
    let authUserValid = false;
    if (vuex && JSON.parse(vuex).hasOwnProperty("auth")) {
        const auth = JSON.parse(vuex).auth;
        if (!isEmpty(auth.user))
            authUserValid = true;
    }
    if (!authUserValid) {
        window.isAuthenticated = false;
        Cookies.remove("access_token");
        Cookies.remove("user_id");
        localStorage.removeItem("access_token");
        localStorage.removeItem("user_id");
        localStorage.removeItem("vuex");
        axios.defaults.headers.common.Authorization = ``;
    }
    else {
        const token = accessToken.replace("%", "|");
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        setTimeout(() => {
            const fcmToken = localStorage.getItem("cmf_token");
            const sendCmfToken = localStorage.getItem("send_cmf_token");
            if (fcmToken != null && sendCmfToken !== "true") {
                NotificationService.postFcmToken({ token: fcmToken }).then(() => {
                    localStorage.setItem("send_cmf_token", "true");
                });
            }
        }, 1000);
        startWebsocket(token);
    }
}
function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
/**
 * Tin chat realtime: Laravel Redis thường gửi `{ type: "chat_message", userIds, messageData }`.
 * Vuex / Messager / SideBar cần object phẳng (có `group_id`, `sender`, …) giống response API.
 */
function unwrapChatMessageSocketPayload(raw) {
    if (!raw || typeof raw !== "object") {
        return raw;
    }
    const md = raw.messageData;
    if (md && typeof md === "object" && md.group_id != null) {
        return md;
    }
    if (md && typeof md === "object") {
        const inner = md.data;
        if (inner && typeof inner === "object" && inner.group_id != null) {
            return inner;
        }
    }
    const directInner = raw.data;
    if (directInner && typeof directInner === "object" && directInner.group_id != null) {
        return directInner;
    }
    if (raw.group_id != null) {
        return raw;
    }
    return raw;
}
/**
 * Redis/socket gửi reaction dạng `{ type, userIds, messageData }` hoặc Laravel Resource `{ data: { ... } }`.
 * Messager / SideBar cần object phẳng có `chat_group_id`, `user_reacted`, `sender`, …
 */
function unwrapReactionEmojiPayload(raw) {
    if (!raw || typeof raw !== "object")
        return null;
    if (raw.action === "login")
        return null;
    const md = raw.messageData;
    if (md && typeof md === "object") {
        const inner = md.data;
        if (inner &&
            typeof inner === "object" &&
            (inner.chat_group_id != null || inner.chat_message_id != null)) {
            return inner;
        }
        if (md.chat_group_id != null || md.chat_message_id != null) {
            return md;
        }
    }
    if (raw.chat_group_id != null || raw.chat_message_id != null) {
        return raw;
    }
    return null;
}
/** Root Vue instance — gán sau `new Vue`; handler socket dùng khi đã mount. */
let app;
/** Tránh gắn chồng listener mỗi lần reconnect / login lại (nguyên nhân OOM). */
let socketHandlersBound = false;
let socketBoundUserId = null;
let socketAuthPayload = null;
let socketTopics = null;
function emitSocketLoginTopics() {
    if (!socketAuthPayload || !socketTopics)
        return;
    if (localStorage.getItem("SOCIAL_DEBUG_CHAT") === "1") {
        console.debug("[socket] emit connect_socket", {
            connected: ws.connected,
            id: ws.id,
            user_id: socketTopics.messageTopic,
        });
    }
    ws.emit("connect_socket", socketAuthPayload);
}
function emitSocketChannelAuth() {
    if (!socketAuthPayload || !socketTopics)
        return;
    const t = socketTopics;
    ws.emit(t.messageTopic, socketAuthPayload);
    ws.emit(t.messageReactionEmojiTopic, socketAuthPayload);
    ws.emit(t.modifyInformationChatTopic, socketAuthPayload);
    ws.emit(t.systemTopic, socketAuthPayload);
    ws.emit(t.userTypingTopic, socketAuthPayload);
    ws.emit(t.userRecall, socketAuthPayload);
}
function resolveSocketUser(token) {
    try {
        const raw = localStorage.getItem("vuex");
        if (raw) {
            const auth = JSON.parse(raw).auth;
            if (auth?.user?.id) {
                return auth.user;
            }
        }
    }
    catch {
        /* ignore */
    }
    if (app?.$store?.state?.auth?.user?.id) {
        return app.$store.state.auth.user;
    }
    const uid = localStorage.getItem("user_id");
    if (uid) {
        return { id: uid };
    }
    void token;
    return null;
}
function startWebsocket(token) {
    const normalizedToken = String(token || "").replace(/%/g, "|");
    if (!normalizedToken) {
        return;
    }
    const user = resolveSocketUser(normalizedToken);
    if (!user?.id) {
        return;
    }
    socketAuthPayload = JSON.stringify({
        action: "login",
        token: normalizedToken,
        user_id: `${user.id}`,
    });
    socketTopics = {
        messageTopic: "message_" + user.id,
        messageReactionEmojiTopic: "message_reaction_emoji_" + user.id,
        modifyInformationChatTopic: "modify_information_chat_" + user.id,
        systemTopic: "system_" + user.id,
        userTypingTopic: "user_typing_" + user.id,
        userRecall: "user_recall_" + user.id,
    };
    // Đã bind đúng user → chỉ re-auth (socket.io tự reconnect).
    if (socketHandlersBound && String(socketBoundUserId) === String(user.id)) {
        if (ws.connected) {
            emitSocketLoginTopics();
        }
        else {
            ws.connect();
        }
        return;
    }
    // Đổi user / lần đầu — gỡ listener cũ rồi gắn một bộ duy nhất.
    ws.removeAllListeners();
    socketHandlersBound = false;
    socketBoundUserId = user.id;
    const messageTopic = socketTopics.messageTopic;
    const messageReactionEmojiTopic = socketTopics.messageReactionEmojiTopic;
    const modifyInformationChatTopic = socketTopics.modifyInformationChatTopic;
    const systemTopic = socketTopics.systemTopic;
    const userTypingTopic = socketTopics.userTypingTopic;
    const userRecall = socketTopics.userRecall;
    ws.on("connect", () => {
        emitSocketLoginTopics();
        if (app) {
            // Mỗi lần socket connected/reconnected, phát event để FE re-sync list + message đang mở.
            app.$store.commit("chat/updateReconnectSocket", { phase: "connect", ts: Date.now() });
        }
    });
    ws.on("reconnect", () => {
        // Socket.io reconnect xong — ép login lại để Node map đúng connection sống.
        emitSocketLoginTopics();
    });
    ws.on("connect_socket", (message) => {
        try {
            const mess = JSON.parse(message);
            if (localStorage.getItem("SOCIAL_DEBUG_CHAT") === "1") {
                console.debug("[socket] connect_socket reply", mess);
            }
            if (mess.action == "login" && mess.status) {
                emitSocketChannelAuth();
            }
            else if (mess.action == "login" && !mess.status) {
                console.warn("[socket] login rejected by server — realtime will miss events");
            }
        }
        catch {
            /* ignore */
        }
    });
    ws.on(messageTopic, (message) => {
        if (!app)
            return;
        const raw = JSON.parse(message);
        if (raw?.type === "chat_read_receipt") {
            app.$store.dispatch("chat/readReceiptSocket", raw);
            return;
        }
        const mess = unwrapChatMessageSocketPayload(raw);
        const fcmToken = localStorage.getItem("cmf_token");
        const sender = mess?.sender;
        const senderId = sender?.id ?? null;
        if (senderId == null || senderId === 0) {
            app.$store.dispatch("chat/dataSocket", mess);
            return;
        }
        if (Number(user.id) === Number(senderId)) {
            if (fcmToken != mess.fcm_token) {
                app.$store.dispatch("chat/dataSocket", mess);
            }
            return;
        }
        app.$store.dispatch("chat/dataSocket", mess);
    });
    ws.on(messageReactionEmojiTopic, (message) => {
        if (!app)
            return;
        let raw;
        try {
            raw = JSON.parse(message);
        }
        catch {
            return;
        }
        const payload = unwrapReactionEmojiPayload(raw);
        if (!payload || payload.user_reacted == null)
            return;
        app.$store.dispatch("chat/dataReactionEmoji", payload);
    });
    ws.on(modifyInformationChatTopic, (message) => {
        if (!app)
            return;
        const chatGroupSelected = app.$store.state.chat.chatGroupSelected || {};
        const mess = JSON.parse(message);
        const md = mess.modifyData;
        const innerData = md?.data ?? mess.data;
        const innerType = md?.type ?? mess.type;
        const joinRequestEvents = [
            "join_request_created",
            "join_request_resolved",
            "join_request_approved",
            "join_request_rejected",
        ];
        const groupInfoEvents = [
            "add_member",
            "remove_member",
            "update_avatar",
            "update_group_name",
            "update_group_rules",
            "join_policy_updated",
            "set_role_admin",
        ];
        const isGroupInfoEvent = groupInfoEvents.includes(innerType) &&
            innerData &&
            String(innerData.group_id) === String(chatGroupSelected.id);
        const retentionEvents = ["message_retention_updated", "message_bulk_deleted", "group_emptied_removed"];
        const isRetentionEvent = retentionEvents.includes(innerType) &&
            innerData &&
            String(innerData.group_id) === String(chatGroupSelected.id);
        if ((innerData &&
            innerData.group_id === chatGroupSelected.id &&
            innerData.sender &&
            Number(innerData.sender.id) === Number(user.id)) ||
            (innerType === "update_message" && innerData && innerData.group_id === chatGroupSelected.id) ||
            (innerType === "poll_voted" && innerData && innerData.group_id === chatGroupSelected.id) ||
            (innerType === "poll_option_added" && innerData && innerData.group_id === chatGroupSelected.id) ||
            (innerType === "poll_vote_message" && innerData && innerData.group_id === chatGroupSelected.id) ||
            isGroupInfoEvent ||
            isRetentionEvent ||
            (joinRequestEvents.includes(innerType) && innerData) ||
            innerType === "PIN_CHAT_GROUP" ||
            mess.type === "PIN_CHAT_GROUP") {
            app.$store.dispatch("chat/modifyMessageSocket", mess);
        }
        if (innerType === "join_request_approved" && innerData && Number(innerData.user_id) === Number(user.id)) {
            import("./helper/chatGroupStore").then(async ({ ensureChatGroupInStore, dedupeChatGroupsById }) => {
                const row = await ensureChatGroupInStore(app.$store, innerData.group_id);
                if (row) {
                    const merged = dedupeChatGroupsById([
                        row,
                        ...(app.$store.state.chat.chatGroups || []),
                    ]);
                    app.$store.commit("chat/updateChatGroups", merged);
                }
                else {
                    await app.$store.dispatch("chat/getChatGroups");
                }
                const groupName = innerData.group_name ? ` "${innerData.group_name}"` : "";
                app.$store.dispatch("alerts/success", `Bạn đã được phê duyệt vào nhóm chat${groupName}.`);
            });
        }
        if (innerType === "join_request_rejected" && innerData && Number(innerData.user_id) === Number(user.id)) {
            const groupName = innerData.group_name ? ` "${innerData.group_name}"` : "";
            app.$store.dispatch("alerts/error", `Yêu cầu tham gia nhóm chat${groupName} đã bị từ chối.`);
        }
        if (innerType === "join_request_created" && innerData?.group_id != null) {
            const selected = app.$store.state.chat.chatGroupSelected || {};
            if (String(selected.id) === String(innerData.group_id) && Number(selected.is_admin) === 1) {
                const requester = innerData.user_name ? ` ${innerData.user_name}` : "";
                app.$store.dispatch("alerts/success", `Có yêu cầu mới${requester} vào nhóm. Xem tab Phê duyệt.`);
            }
        }
        if (innerType === "message_retention_updated" && innerData) {
            app.$store.dispatch("chat/getChatGroups");
        }
        if (innerType === "join_policy_updated" && innerData?.group_id != null) {
            const joinPolicy = Number(innerData.join_policy) === 2 ? 2 : 1;
            const chatGroups = app.$store.state.chat.chatGroups || [];
            const updated = Array.isArray(chatGroups)
                ? chatGroups.map((g) => {
                    if (String(g.id) !== String(innerData.group_id))
                        return g;
                    return {
                        ...g,
                        settings: { ...(g.settings || {}), join_policy: joinPolicy },
                    };
                })
                : chatGroups;
            app.$store.commit("chat/updateChatGroups", updated);
            const selected = app.$store.state.chat.chatGroupSelected || {};
            if (String(selected.id) === String(innerData.group_id)) {
                app.$store.commit("chat/updateChatGroupSelected", {
                    ...selected,
                    settings: { ...(selected.settings || {}), join_policy: joinPolicy },
                });
            }
        }
        if (innerType === "group_emptied_removed" && innerData) {
            app.$store.dispatch("chat/getChatGroups");
            try {
                const cur = router.currentRoute;
                if (cur && String(cur.params?.messenger_id ?? "") === String(innerData.group_id)) {
                    router.replace("/new-feeds").catch(() => { });
                }
            }
            catch (_) {
                /* router không sẵn — bỏ qua */
            }
        }
        if (innerType === "remove_member" && innerData?.group_id != null) {
            let removedSelf = false;
            try {
                const note = innerData.system_note
                    ? JSON.parse(String(innerData.system_note))
                    : [];
                if (Array.isArray(note)) {
                    removedSelf = note.some((row) => Number(row?.id) === Number(user.id));
                }
            }
            catch {
                removedSelf = false;
            }
            if (removedSelf) {
                import("./helper/chatAccessRedirect").then(({ redirectAfterChatGroupAccessLost }) => {
                    redirectAfterChatGroupAccessLost({
                        groupId: String(innerData.group_id),
                        router,
                        store: app?.$store,
                    });
                });
            }
        }
    });
    ws.on(systemTopic, (message) => {
        try {
            const mess = JSON.parse(message);
            if (mess.is_banned && mess.is_banned === true) {
                import("./helper/sessionRedirect").then(({ clearClientSession, redirectToLoginPage }) => {
                    clearClientSession();
                    redirectToLoginPage();
                });
                return;
            }
            if (mess.update_user_avatar && app) {
                const current = app.$store.state.auth?.user || {};
                if (current.id) {
                    app.$store.commit("updateUser", {
                        ...current,
                        avatar_url: mess.avatar_url ?? current.avatar_url,
                        thumbnail: mess.thumbnail ?? current.thumbnail,
                    });
                }
            }
        }
        catch {
            /* ignore */
        }
    });
    ws.on(userTypingTopic, (message) => {
        if (!app)
            return;
        const mess = JSON.parse(message);
        const d = mess?.data;
        const md = mess?.messageData?.data;
        let payload = null;
        if (d?.user_typing != null && d?.chat_group != null) {
            payload = d;
        }
        else if (md?.user_typing != null && md?.chat_group != null) {
            payload = md;
        }
        else if (mess?.user_typing != null && mess?.chat_group != null) {
            payload = mess;
        }
        const typingUser = payload?.user_typing;
        if (localStorage.getItem("SOCIAL_DEBUG_CHAT") === "1") {
            console.debug("[chat:typing] keys", Object.keys(mess), "resolved", !!payload, typingUser);
        }
        if (!typingUser?.id || Number(user.id) === Number(typingUser.id)) {
            return;
        }
        app.$store.dispatch("chat/dataUserTyping", payload);
    });
    ws.on(userRecall, (message) => {
        if (!app)
            return;
        try {
            const mess = JSON.parse(message);
            const md = mess.messageData;
            const payload = md?.data ?? mess.data ?? mess;
            if (payload &&
                typeof payload === "object" &&
                payload.group_id != null &&
                payload.chat_message_id != null) {
                app.$store.dispatch("chat/dataUserRecall", payload);
            }
        }
        catch {
            /* ignore malformed recall payload */
        }
    });
    // Không gọi startWebsocket() lại ở đây — socket.io tự reconnect. Vẫn phát event để FE fallback sync.
    ws.on("disconnect", () => {
        if (app) {
            app.$store.commit("chat/updateReconnectSocket", { phase: "disconnect", ts: Date.now() });
        }
    });
    socketHandlersBound = true;
    if (ws.connected) {
        emitSocketLoginTopics();
    }
    else {
        ws.connect();
    }
}
// Auth / bootstrap SSO gọi lại cùng socket (không tạo io() mới).
window.startWebsocket = startWebsocket;
function storageListener() {
    const firebaseMessage = localStorage.getItem("firebase_message");
    if (app && firebaseMessage != null) {
        app.$store.dispatch("alerts/firebaseNotification", JSON.parse(firebaseMessage));
    }
}
startAutoVersionReload();
window.addEventListener("storage", storageListener);
localStorage.setItem("create_post_modal_open", "false");
app = new Vue({
    router,
    store,
    ws,
    el: "#app",
    render: (h) => h(App),
});
store.$app = app;
window.app = app;
// Sau khi Vue mount: ép socket login lại (tránh connected nhưng chưa map user trên Node).
{
    const t = localStorage.getItem("access_token");
    if (t) {
        startWebsocket(String(t).replace(/%/g, "|"));
    }
}
if (!accessToken || accessToken === "") {
    loadSsoConfig()
        .then((cfg) => {
        if (cfg && cfg.enabled) {
            return store.dispatch("bootstrapSso");
        }
        return null;
    })
        .then((res) => {
        if (res && res.status) {
            const t = localStorage.getItem("access_token");
            if (t) {
                startWebsocket(String(t).replace("%", "|"));
            }
        }
    })
        .catch(() => undefined);
}
